import React from "react";
import PropTypes from "prop-types";
import styles from "./PricingOptionWide.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

const importAll = (r) => {
  let images = {};
  r.keys().forEach((item, index) => {
    images[item.replace("./", "")] = r(item);
  });
  return images;
};

const images = importAll(
  require.context("../../assets", false, /\.(png|jpe?g|svg)$/)
);

const PricingOptionWide = ({
  packageName,
  priceMonthly,
  priceAnnual,
  onMonthly,
  onAnnual,
  sections,
}) => {
  const logos = sections.map((item, index) => (
    <div key={index}>
      {item.section.logo.length > 0 ? (
        <img
          className={styles.logo}
          src={images[item.section.logo]}
          alt="logo"
        />
      ) : null}
    </div>
  ));

  const features = sections.map((item, index) => (
    <div key={index}>
      <h4 className={styles.header}>{item.section.header}</h4>
      <ul>
        {item.section.features != null ? (
          item.section.features.map((feature, index) => (
            <li key={index}>
              <FontAwesomeIcon icon={faCheck} className={styles.icon} />
              {feature.feature}{" "}
              <span style={{ fontWeight: "bold" }}>{feature.isNew}</span>
            </li>
          ))
        ) : (
          <></>
        )}
      </ul>
    </div>
  ));

  return (
    <div className={styles.container}>
      <div className={styles.row}>
        <div className="col" id={styles.logoSection}>{logos}</div>
        <div className="col" id={styles.featureSection}>{features}</div>
      </div>
      <div className={styles.row}>
        <div className="col" id={styles.pricing}>
          <p className={styles.bold}>{packageName} Monthly Subscription</p>
          <p>
            ${priceMonthly}
            <button className={styles.button} onClick={onMonthly}>
              Sign Up
            </button>
          </p>
        </div>
        <div className="col" id={styles.pricing}>
          <p className={styles.bold}>
            {" "}
            {packageName}
            <br /> Annual Subscription
          </p>
          <p>
            ${priceAnnual}
            <button className={styles.button} onClick={onAnnual}>
              Sign Up
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

PricingOptionWide.propTypes = {
  packageName: PropTypes.string.isRequired,
  priceMonthly: PropTypes.string.isRequired,
  priceAnnual: PropTypes.string.isRequired,
  onMonthly: PropTypes.func.isRequired,
  onAnnual: PropTypes.func.isRequired,
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      section: PropTypes.shape({
        logo: PropTypes.string,
        header: PropTypes.string,
        features: PropTypes.arrayOf(
          PropTypes.shape({
            feature: PropTypes.string,
          })
        ),
      }),
    })
  ),
};

export default PricingOptionWide;
